var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: {
            rules: _vm.rules,
            model: _vm.childData,
            inline: "",
            "label-position": "right",
            "label-width": "90px"
          }
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("table.deviceSerno"),
                        prop: "deviceSerno"
                      }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px" },
                        model: {
                          value: _vm.childData.deviceSerno,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "deviceSerno", $$v)
                          },
                          expression: "childData.deviceSerno"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("table.deviceName"),
                        prop: "deviceName"
                      }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px" },
                        model: {
                          value: _vm.childData.deviceName,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "deviceName", $$v)
                          },
                          expression: "childData.deviceName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("table.brandNameValue"),
                        prop: "brandNameValue"
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "form-item-width",
                          attrs: { placeholder: "请选择品牌名称" },
                          model: {
                            value: _vm.childData.brandNameValue,
                            callback: function($$v) {
                              _vm.$set(_vm.childData, "brandNameValue", $$v)
                            },
                            expression: "childData.brandNameValue"
                          }
                        },
                        _vm._l(_vm.brandOption, function(item) {
                          return _c("el-option", {
                            key: item.dicValue,
                            attrs: {
                              label: item.dicName,
                              value: item.dicValue
                            },
                            on: { change: _vm.changeBrandValue }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("table.deviceIp") } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px" },
                        model: {
                          value: _vm.childData.deviceIp,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "deviceIp", $$v)
                          },
                          expression: "childData.deviceIp"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("table.sysType"), prop: "sysType" }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "form-item-width",
                          attrs: { placeholder: "请选择所属系统" },
                          model: {
                            value: _vm.childData.sysType,
                            callback: function($$v) {
                              _vm.$set(_vm.childData, "sysType", $$v)
                            },
                            expression: "childData.sysType"
                          }
                        },
                        _vm._l(_vm.sysTypeOption, function(item) {
                          return _c("el-option", {
                            key: item.dicValue,
                            attrs: {
                              label: item.dicName,
                              value: item.dicValue
                            },
                            on: { change: _vm.changeSysValue }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("table.deviceFlag"),
                        prop: "deviceFlag"
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "form-item-width",
                          attrs: { placeholder: "请选择设备标识" },
                          model: {
                            value: _vm.childData.deviceFlag,
                            callback: function($$v) {
                              _vm.$set(_vm.childData, "deviceFlag", $$v)
                            },
                            expression: "childData.deviceFlag"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "重要设备", value: "1" }
                          }),
                          _c("el-option", {
                            attrs: { label: "一般设备", value: "0" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("table.deviceAddress") } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px" },
                        model: {
                          value: _vm.childData.deviceAddress,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "deviceAddress", $$v)
                          },
                          expression: "childData.deviceAddress"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("table.equipType") } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px" },
                        model: {
                          value: _vm.childData.equipType,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "equipType", $$v)
                          },
                          expression: "childData.equipType"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("el-row"),
          _c("el-row"),
          _c(
            "el-row",
            { attrs: { type: "flex" } },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("table.deviceDesc") } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px" },
                        attrs: {
                          type: "textarea",
                          autosize: { minRows: 4, maxRows: 6 }
                        },
                        model: {
                          value: _vm.childData.deviceDesc,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "deviceDesc", $$v)
                          },
                          expression: "childData.deviceDesc"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.handCancle } }, [
            _vm._v(_vm._s(_vm.$t("button.cancel")))
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handCreate } },
            [_vm._v(_vm._s(_vm.$t("button.confirm")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }